import {
  createContext,
  ReactElement,
  useContext,
  useCallback,
  useEffect,
} from 'react'
import axios from 'axios'

import { FormOption, normalizeOptions, Question, Response } from '../_ui/_types'
import { AppContext, AppSettings } from '../providers'
import { Fetcher } from '../_types'

import { Responses as ResponsesMock } from '../_mocks'

const {
  REACT_APP_BASE_API
} = process.env

export const normalizeResponse = (r: any): Response => {
  const response = r.results || r
  const id = Number(response?.id) as number

  return {
    id,
  }
}
export type APIResponse = any

export interface NetworkroviderProps {
  children: ReactElement | ReactElement[]
}

export const normalizeQuestion = (r: any): Question | any => {
  const question = r.results || r
  const id = question.id as number
  const options = normalizeOptions(question.options) as FormOption[]
  const response = normalizeResponse(question.response) as Response

  return {
    ...question,
    options,
    response,
    id,
  }
}

// const API = {
//   get: (url: string, config: any) => {
//     const siteURL = `${REACT_APP_BASE_API}/${url}`
//     return axios.get(siteURL, config)
//   },
//   post: (url: string, config: any) => {
//     const siteURL = `${REACT_APP_BASE_API}/${url}`
//     return axios.post(siteURL, config)
//   },
// }

const API = {
  get: (url: string, config: any) => {
    const siteURL = `${url}`
    return axios.get(siteURL, config)
  },
  post: (url: string, config: any) => {
    const siteURL = `${url}`
    return axios.post(siteURL, config)
  },
}

export interface INetworkFetcherProps {
  url: string
  site: string
}
export interface INetworkContext {
  networkFetcher: (
    fetcher?: Fetcher
  ) => (url: string) => Promise<APIResponse>
}

const initialContext: INetworkContext = {} as INetworkContext
export const NetworkContext = createContext(initialContext)

export const NetworkProvider: React.FC<NetworkroviderProps> = ({
  children,
}) => {
  const { setAppSettings } = useContext(AppContext)

  useEffect(() => {
    setAppSettings((oldSettings: AppSettings) => ({
      ...oldSettings,
      isLoaded: true,
    }))
  }, [setAppSettings])

  const networkFetcher = useCallback(
    (
      { normalizer, normalizerArgs, method = 'GET', body, site = '' }: Fetcher = { method: 'GET' }
    ) => {
      if (method === 'POST') {
        return async (url: string) => {
          // const basicHeaders = await getAPIHeaderAsync()
          const result = await API.post(url, {
            // headers: { ...basicHeaders, 'Content-Type': 'application/json' },
            headers: { 'Content-Type': 'application/json' },
            body,
          })
          return normalizer?.(result, site, normalizerArgs) || result
        }
      } else if (method === 'GET') {
        return async (url: string) => {
          const { data } = await API.get(url, {
            // headers: await getAPIHeaderAsync(),
          })
          return normalizer?.(data, site, normalizerArgs) || data
        }
      } else {
        return async () => {
          const result = ResponsesMock.Presentations._mockPresentation_0
          return normalizer?.(result, site, normalizerArgs) || result
        }
      }
    },
    []
  )

  const contextValues = {
    networkFetcher,
  }

  return (
    <NetworkContext.Provider value={contextValues}>
      {children}
    </NetworkContext.Provider>
  )
}

export default NetworkProvider
